import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

export const fetchDiagnosisCodes = createAsyncThunk(
  "diagnosisCodes/fetchDiagnosisCodes",
  async (params = {}, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const queryParams = new URLSearchParams();
      if (params.search) queryParams.append("search", params.search);
      if (params.active !== undefined) queryParams.append("active", params.active);

      const response = await axios.get(
        `${baseURL}/api/diagnosis-codes?${queryParams.toString()}`,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const createDiagnosisCode = createAsyncThunk(
  "diagnosisCodes/createDiagnosisCode",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.post(
        `${baseURL}/api/diagnosis-codes`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const updateDiagnosisCode = createAsyncThunk(
  "diagnosisCodes/updateDiagnosisCode",
  async ({ id, data }, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.put(
        `${baseURL}/api/diagnosis-codes/${id}`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);
